import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiService} from './base-api.service';
import {AuthApiService} from "./auth-api.service";
import {ConfigService} from "./config.service";

@Injectable()
export class BusinessService extends BaseApiService {


  public edPath: string;

  constructor(public http: HttpClient, private auth: AuthApiService, private configService: ConfigService) {
    super();
    this.edPath = auth.user.ed && auth.user.ed.path;
  }

  public get url(): string {
    return this.configService.apiEndpoint + '/api/ed/' + this.edPath + '/businesses';
  }

  all() {
    return this.get('/');
  }


}
